module.exports = __webpack_public_path__ + "img/hardyClub2.5a60c5d3.png";